<template>
  <div>
  <el-dialog title="创建结算单" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="结算月份"  :label-width="formLabelWidth">
        <div class="block">
          <el-date-picker
            type="months"
            v-model="form.month"
            value-format="yyyy-MM"
            placeholder="选择一个或多个月">
          </el-date-picker>
        </div>
        <span class="red">请确定结算月份，请不要重复结算</span>
      </el-form-item>
      <el-form-item label="会员等级" :label-width="formLabelWidth">
        <el-select v-model="form.grade_id" multiple placeholder="-请选择等级-">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="分红比例" :label-width="formLabelWidth">
        <el-input v-model="form.rate" min='0'   style="width: 160px;" autocomplete="off"></el-input>
        <span class="ml10">%</span>
        <div class="lh18 mt10 gray9">
          <p>注：最终总分红奖金池 = 总业绩 x 分红比例；对应等级人员平均分 </p>
        </div>
      </el-form-item>
      <el-form-item label="分红类型" :label-width="formLabelWidth">
        <el-radio v-model="form.type" label="1">平均分红</el-radio>
          <el-radio v-model="form.type" label="2">加权分红</el-radio>
          <div class="gray9">平均分红：根据当月总业绩与对应等级人数平均分配；</div>
          <div class="gray9">加权分红：根据当月用户的实际团队业绩占总业绩的 比例百分比分红</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="add" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
  import BonusApi from '@/api/weightbonus.js';
  export default {
    components: {
    },
    data() {
      return {
        /*省市区*/
        gradeList: {},
        open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        /*form表单数据*/
        user:{},
        form: {
          grade_id: '',
          rate:0,
          month: '',
          type:0,
        },
      };
    },
    props: ['open_add'],
    created() {

      this.dialogVisible = this.open_add;
       this.getGrade();

    },
    methods: {
      // 获取等级
      getGrade(){
        let self = this;
        BonusApi.getGradeList({}, true)
        .then(res => {
          self.gradeList = res.data.grade;
        })
        .catch(error => {

        });
      },
      /*添加*/
      add() {
        let self = this;
        let params = self.form;
        if(!params.month){
            this.showMessage('请选结算月份');
            return ;
        }
        if(!params.grade_id){
            this.showMessage('请选择等级');
            return ;
        }
        
        if(!params.rate){
            this.showMessage('请设置结算参数');
            return ;
        }
        self.$confirm('确定结算选定的月份吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          BonusApi.add(params, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，操作成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
      },
      showMessage(msg='信息不能为空'){
        this.$message({
            message: msg,
            type: 'warning'
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*打开用户弹窗*/
    openUserDialog() {
      this.open_user = true;
    },
    /*关闭用户弹窗*/
    closeUserDialog(e) {
      if (e.type != 'error') {
        this.user = e.params[0];
        console.log(e.params[0])
        this.form.user_id = e.params[0].user_id;
      }
      this.open_user = false;
    },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/weightbonus/bonus/dialog/Add.vue